import React from "react";
import { useCookies } from "react-cookie";
import dayjs from "dayjs";
import "dayjs/locale/id";
import "dayjs/locale/en";

const BeritaOverlayCard = ({ item, href }) => {
    const [cookies] = useCookies(["i18next"]);

    const convertToSlug = (title) => {
        if (!title) return "";
        return title
            .toLowerCase()
            .trim()
            .replace(/[^\w\s-]/g, "")
            .replace(/\s+/g, "-")
            .replace(/-+/g, "-");
    };

    // [PERBAIKAN]: Instance locale agar tidak mutasi bahasa secara global
    const formatDate = (date, locale = "en") => {
        return dayjs(date).locale(locale).format("DD MMMM YYYY");
    };

    const titleText = cookies.i18next === "id" ? item.title : item.title_en || item.title;
    const linkHref = href || `/berita-kegiatan/${btoa(item.id)}/${convertToSlug(item.title)}`;

    const renderTags = () => {
        let parsedTags = [];

        if (Array.isArray(item.tags)) {
            parsedTags = item.tags.map(t => t.value);
        } else if (item.tag && typeof item.tag === "string") {
            try {
                const jsonTags = JSON.parse(item.tag);
                if (Array.isArray(jsonTags)) {
                    parsedTags = jsonTags.map(t => t.value);
                } else {
                    parsedTags = item.tag.split(",");
                }
            } catch (e) {
                parsedTags = item.tag.split(",");
            }
        } else if (item.tags && typeof item.tags === "string") {
            try {
                const jsonTags = JSON.parse(item.tags);
                if (Array.isArray(jsonTags)) {
                    parsedTags = jsonTags.map(t => t.value);
                } else {
                    parsedTags = item.tags.split(",");
                }
            } catch (e) {
                parsedTags = item.tags.split(",");
            }
        }

        if (parsedTags.length === 0) return null;

        return parsedTags.slice(0, 2).map((tag, index) => (
            <span key={index} className="me-2 text-white" style={{ background: "rgba(0, 153, 75, 0.8)", padding: "2px 8px", borderRadius: "4px" }}>
                {tag && tag.trim() !== "" ? "#" + tag.trim() : ""}
            </span>
        ));
    };

    // [BARU]: Fungsi untuk merender base URL CMS
    const resolveImageUrl = (path, type = 'news') => {
        if (!path || path === "") return '/assets/image/foto-beritas.png';
        if (path.startsWith('http://') || path.startsWith('https://')) return path;
        const cleanPath = path.startsWith('/') ? path : `/${path}`;
        if (cleanPath.startsWith('/assets/') || cleanPath.startsWith('/static/')) return cleanPath;
        if (path.includes('uploads/') || path.includes('storage/')) {
            const cmsUrl = process.env.REACT_APP_API_URL || 'https://cms.kneks.go.id';
            return `${cmsUrl.replace(/\/$/, '')}${cleanPath}`;
        }
        if (type === 'gallery') {
            const base = (process.env.REACT_APP_API_PHOTO_BERITA || 'https://cms.kneks.go.id/uploads/photo/').replace(/\/?$/, '/');
            return `${base}${path.replace(/^\//, '')}`;
        }
        const base = (process.env.REACT_APP_API_NEWS || 'https://cms.kneks.go.id/storage/news/').replace(/\/?$/, '/');
        return `${base}${path.replace(/^\//, '')}`;
    };

    // [BARU]: Fungsi Regex untuk memotong URL gabungan dari API
    const getFirstImage = () => {
        const rawData = item?.image || item?.images || item?.foto_gallery?.[0]?.foto;

        if (!rawData) return '/assets/image/foto-beritas.png';

        const rawString = Array.isArray(rawData) ? rawData[0] : String(rawData);
        const type = (rawData === item?.foto_gallery?.[0]?.foto) ? 'gallery' : 'news';

        const firstUrl = rawString.replace(/,.*/, '').trim();

        if (firstUrl) {
            return resolveImageUrl(firstUrl, type);
        }

        return '/assets/image/foto-beritas.png';
    };

    return (
        <div className="berita-card h-100 position-relative" style={{ borderRadius: "12px", overflow: "hidden", boxShadow: "0 4px 20px rgba(0,0,0,0.1)", minHeight: "350px", display: "block" }}>
            <a href={linkHref} className="d-block w-100 h-100 position-absolute" style={{ zIndex: 3 }}></a>

            {/* [PERBAIKAN]: Menggunakan fungsi getFirstImage pada src */}
            <img
                src={getFirstImage()}
                onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = `/assets/image/foto-beritas.png`;
                }}
                className="img-fluid w-100 h-100 position-absolute"
                style={{ objectFit: "cover", top: 0, left: 0, transition: "transform 0.5s ease" }}
                alt={titleText}
                onMouseOver={e => e.currentTarget.style.transform = "scale(1.05)"}
                onMouseOut={e => e.currentTarget.style.transform = "scale(1)"}
            />

            {/* Overlay gradient - thin background */}
            <div
                className="position-absolute w-100 h-100"
                style={{
                    background: "linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 50%, rgba(0,0,0,0) 100%)",
                    top: 0, left: 0, pointerEvents: "none", zIndex: 1
                }}
            ></div>

            <div className="position-absolute w-100 d-flex flex-column p-4" style={{ bottom: 0, left: 0, zIndex: 2 }}>
                <div className="event-card-info-x mb-1" style={{ fontSize: "0.75rem", fontWeight: "600" }}>
                    {renderTags()}
                </div>

                <div className="event-card-title mb-2">
                    <h4 style={{ margin: 0 }}>
                        <span
                            style={{
                                display: "-webkit-box",
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                fontSize: "1.2rem",
                                fontWeight: "700",
                                color: "#ffffff",
                                lineHeight: "1.4",
                                textShadow: "0 2px 4px rgba(0,0,0,0.5)"
                            }}
                        >
                            {titleText}
                        </span>
                    </h4>
                </div>

                <div className="event-card-info d-flex align-items-center text-white" style={{ fontSize: "0.85rem", opacity: 0.8 }}>
                    <i className="fa-regular fa-calendar me-2"></i>
                    <span>
                        {cookies.i18next === "id"
                            ? formatDate(item.news_datetime || item.created_at, "id")
                            : formatDate(item.news_datetime || item.created_at, "en")}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default BeritaOverlayCard;